(function () {
  const interval = setInterval(() => {
    if (window.fbq?.callMethod) {
      window.clearInterval(interval)
      const _fbq_callMethod = window.fbq.callMethod || function () {}
      window.fbq.callMethod = function () {
        console.log(arguments)
        try {
          if (arguments[1] === 'AddToCart') {
            arguments[2].content_category = window.meta.product.type
            arguments[2].content_name = window.meta.product.variants[0].name
            arguments[2].content_type = 'product_group'
            arguments[2].content_ids = [window.meta.product.id]
            arguments[2].value = window.meta.product.variants[0].price / 100
            arguments[2].currency = window.ShopifyAnalytics.meta.currency
          }
        } catch (error) {
          console.error(error)
        }
        _fbq_callMethod.apply(window.fbq, arguments)
      }
    }
  }, 250)
})();
